import { useContext, useEffect, useState } from "react";
import { eREPORT, ePrivileges } from "../../../utils/enum";
import ScheduleDataList from "../reports/schedule-list";
import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "../entity/entity.module.css";
import ReportDataList from "../reports/report-list";
import SummaryList from "./summary-list";

function ReportList() {
  const context: any = useContext(UserContext);
  const [activeReport, setActiveReport] = useState<string>("");

  useEffect(() => {
    setActiveReport(
      Utils.isUserHasAccess(
        context.user?.privilegeList,
        ePrivileges.VIEWREPORTLIST
      )
        ? eREPORT.REPORTLIST
        : Utils.isUserHasAccess(
              context.user?.privilegeList,
              ePrivileges.VIEWSCHEDULELIST
            )
          ? eREPORT.SCHEDULELIST
          : Utils.isUserHasAccess(
                context.user?.privilegeList,
                ePrivileges.DOWNLOADAMCSUMMARYREPORT
              )
            ? eREPORT.SUMMARYREPORTLIST
            : ""
    );
  }, [context?.user]);

  return (
    <div>
      <div className={styles.parentContainer}>
        {/* Check if user has permission to view already downloaded report list */}
        {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWREPORTLIST
        ) && (
          <div
            className={`${styles.tab} ${
              activeReport === eREPORT.REPORTLIST ? styles.activeTab : ""
            }`}
            onClick={() => {
              setActiveReport(eREPORT.REPORTLIST);
            }}
          >
            <span
              className={
                activeReport === eREPORT.REPORTLIST
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Report
            </span>
          </div>
        )}
        {/* Check if user has permission to view already created schedules list */}
        {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWSCHEDULELIST
        ) && (
          <div
            className={`${styles.tab} ${
              activeReport === eREPORT.SCHEDULELIST ? styles.activeTab : ""
            }`}
            onClick={() => {
              setActiveReport(eREPORT.SCHEDULELIST);
            }}
          >
            <span
              className={
                activeReport === eREPORT.SCHEDULELIST
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Schedule
            </span>
          </div>
        )}

        {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.DOWNLOADAMCSUMMARYREPORT
        ) && (
          <div
            className={`${styles.tab} ${
              activeReport === eREPORT.SUMMARYREPORTLIST ? styles.activeTab : ""
            }`}
            onClick={() => {
              setActiveReport(eREPORT.SUMMARYREPORTLIST);
            }}
          >
            <span
              className={
                activeReport === eREPORT.SUMMARYREPORTLIST
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              AMC Summary Report
            </span>
          </div>
        )}
      </div>
      <div>
        {activeReport === eREPORT.REPORTLIST ? (
          <ReportDataList />
        ) : activeReport === eREPORT.SCHEDULELIST ? (
          <ScheduleDataList />
        ) : activeReport === eREPORT.SUMMARYREPORTLIST ? (
          <SummaryList></SummaryList>
        ) : null}
      </div>
    </div>
  );
}

export default ReportList;
